import XCaptchaInput from '~/components/XCaptchaInput/index.vue'
import { type ColumnsItem } from '~/features/form'

export const formColumns: () => ColumnsItem[] = () => {
  const { $t } = useNuxtApp()
  return [
    {
      key: 'name',
      inputAttrs: {
        disabled: true,
      },
      formItem: {
        label: $t('guan-li-yuan'),
        name: 'name',
      },
    },
    {
      ...(isGlobalVersion()
        ? {
            key: 'email',
            inputAttrs: {
              disabled: true,
            },
            formItem: {
              label: $t('you-xiang'),
              name: 'email',
            },
          }
        : {
            key: 'phone',
            inputAttrs: {
              disabled: true,
            },
            formItem: {
              label: $t('shou-ji-hao-ma'),
              name: 'phone',
            },
          }),
    },
    {
      key: 'code',
      inputAttrs: {},
      formItem: {
        label: $t('yan-zheng-ma'),
        name: 'code',
        rules: [
          { required: true, message: $t('qing-shu-ru-yan-zheng-ma') },
          { max: 6, message: $t('yan-zheng-ma-chang-du-wei-6-wei') },
        ],
      },
      render: (row: any) =>
        h(XCaptchaInput, {
          placeholder: $t('qing-shu-ru-yan-zheng-ma'),
          data: isGlobalVersion() ? row.email : row.phone,
          value: row.code,
          'onUpdate:value': (v: any) => (row.code = v),
        }),
    },
    {
      key: 'account_id',
      inputAttrs: {
        type: 'select',
        options: [],
      },
      formItem: {
        label: $t('zhuan-rang-dui-xiang'),
        name: 'account_id',
        rules: [
          { required: true, message: $t('qing-xuan-ze-zhuan-rang-dui-xiang') },
        ],
      },
    },
  ]
}

export const Icons = {
  filter: h(
    'svg',
    {
      class: 'w-[16px] h-[16px]',
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16',
      versio: '1.1',
    },
    [
      h('path', {
        fill: 'currentColor',
        d: 'M13.7515625,2.40625 L2.2484375,2.40625 C1.865625,2.40625 1.6265625,2.8234375 1.81875,3.15625 L5.453125,9.334375 L5.453125,13.09375 C5.453125,13.3703125 5.675,13.59375 5.95,13.59375 L10.05,13.59375 C10.325,13.59375 10.546875,13.3703125 10.546875,13.09375 L10.546875,9.334375 L14.1828125,3.15625 C14.3734375,2.8234375 14.134375,2.40625 13.7515625,2.40625 Z M9.428125,12.46875 L6.571875,12.46875 L6.571875,10.03125 L9.4296875,10.03125 L9.4296875,12.46875 L9.428125,12.46875 Z M9.578125,8.771875 L9.4296875,9.03125 L6.5703125,9.03125 L6.421875,8.771875 L3.3234375,3.53125 L12.6765625,3.53125 L9.578125,8.771875 Z',
      }),
    ]
  ),
  search: h(
    'svg',
    {
      class: 'w-[16px] h-[16px]',
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16',
      versio: '1.1',
    },
    [
      h('path', {
        fill: 'currentColor',
        d: 'M7.13379715,1.475 C7.89730691,1.475 8.63859922,1.62441242 9.33655527,1.91902251 C10.0103867,2.20344689 10.6156199,2.61064528 11.135086,3.1290357 C11.6545334,3.64742313 12.0625773,4.25144814 12.3476134,4.92397567 C12.6428483,5.62059733 12.792579,6.36045558 12.792579,7.12250501 C12.792579,7.88454483 12.6428461,8.62441789 12.347634,9.32098559 C12.1710637,9.73810401 11.9447742,10.1320004 11.6739415,10.4942616 L11.492,10.721 L11.534,10.669 L13.5445726,12.6755073 C13.7584125,12.8889108 13.7821725,13.2202815 13.6158526,13.4599 L13.5445726,13.5450464 C13.4276267,13.6617537 13.2713354,13.725 13.1092755,13.725 C12.9471765,13.725 12.7909492,13.6617785 12.6739627,13.5450308 L10.661,11.536 L10.4892158,11.6707752 C10.2218333,11.867763 9.93812706,12.040337 9.63975405,12.1874294 L9.33655346,12.3259883 C8.63858908,12.6205862 7.89729674,12.7699947 7.13379715,12.7699947 C6.37029757,12.7699947 5.62900522,12.6205862 4.93104034,12.3259881 C4.25721046,12.0415734 3.65196392,11.6343699 3.13252499,11.115991 C2.61306325,10.5976049 2.20501786,9.99357961 1.91998184,9.32103655 C1.62473683,8.62442801 1.475,7.88455498 1.475,7.12250501 C1.475,6.36045504 1.62473683,5.62058201 1.91998209,4.9239729 C2.20502722,4.25143965 2.61307937,3.64740437 3.13252232,3.12903703 C3.65195117,2.61065247 4.25717901,2.20345894 4.93103865,1.91902267 C5.62900028,1.62441022 6.37027775,1.475 7.13379715,1.475 Z M7.13379715,2.66915451 C5.9414529,2.66915451 4.82113966,3.13225406 3.97809013,3.97359818 C3.135075,4.81489307 2.67108507,5.93278399 2.67108507,7.12250501 C2.67108507,8.31222603 3.135075,9.43011695 3.97808935,10.2714111 C4.8211636,11.1127501 5.94148166,11.5758555 7.13379715,11.5758555 C8.32611264,11.5758555 9.4464307,11.1127501 10.2895034,10.2714126 C11.1325176,9.43010376 11.5965092,8.31222205 11.5965092,7.12250501 C11.5965092,5.93278246 11.1325137,4.8148875 10.2895042,3.97359818 C9.44643584,3.13225019 8.32613587,2.66915451 7.13379715,2.66915451 Z',
      }),
    ]
  ),
}
